var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat3NewHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new-hair3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M519,189c-0.1-0.9,0.1-1.9,0-2.5c-10-83.3-101.5-94.6-149.2-96C319.9,89,226.2,106,205.3,173.8h-0.1 c-0.2,0.8-0.4,1.7-0.6,2.5c-0.6,2.3-1.2,4.7-1.7,7.2c-9.1,41.6-9.1,95.1-1.7,130.3c4.7-36.7,12.8-135.3,60-132.7l-23.8-3.1 c5.1-4.4,10.3-8.8,16-12.2c46.4-28.4,103-30,155.3-21.8c25,3.9,50.5,12.5,73.1,23.8c4.9,2.4,9.1,6.5,12.9,11.1l-33.1,6.6 c11.7,6,22.6,20.1,25.5,23.5c18,20.5,26.5,87.5,24,132C516.7,317.9,525.8,224,519,189z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat3_8_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M550.1,150.5c-1.4-20.8-36.8-21.1-52.3-22.2c-45.5-3.3-89.9,5.3-136.5,4.9c-32.7-0.2-67.3-3.7-102.8-6.8 l-4.2-0.6c-13.8-2-38.6,1.2-52.9,4.9c-16.6,4.3-39.6,16.8-27.1,38.2c8.1,13.8,34.7,30.5,48.7,36.4c18.7,7.8,33.2,13,52.9,17.7 c39.4,9.4,80.1,5.8,119.6,0.8c40.4-5.1,79.5-13.8,116.8-33.1C526.8,183.3,551.5,170.4,550.1,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F3C1B",
    d: "M449.3,62c-10.7-5.5-24.3-8.7-35.3-13.6c-11.3-5.1-17.2-14.6-28.1-21.3c-23.6-14.3-57.5,3.2-77.7,17.1 c-25.6,17.8-42.8,5.9-60.1,28.3c-8.3,10.8-9.2,26.9-9.6,40.3c-0.2,8.2,0.4,21.6,1.4,33.8c1.5,1,3.1,2,4.6,3 c61.5,37.8,143.3,41.5,209.9,11.8c6.4-3,12.6-6.3,18.7-10.1c1.5-0.9,3.1-1.9,4.6-2.9c-0.2-5.1-0.4-9.8-0.7-13 C474.5,108,477.4,76.5,449.3,62z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CCB37F",
    d: "M475.3,111.3c-1,0.5-1.9,0.9-2.9,1.4c-6.3,2.9-12.7,5.6-19.2,8c-64.2,22.5-136.3,21.3-198.9-5.2 c-5.3-2.3-10.5-4.7-15.6-7.3c-0.1,1.6-0.1,3.2-0.2,4.7c-0.2,8.2,0.4,21.6,1.4,33.8c1.5,1,3.1,2,4.6,3 c61.5,37.8,143.3,41.5,209.9,11.8c6.4-3,12.6-6.3,18.7-10.1c1.5-0.9,3.1-1.9,4.6-2.9c-0.2-5.1-0.4-9.8-0.7-13 C476.3,127.6,476,119.4,475.3,111.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M362.6,86.5c23.3-3.7,39.2-19.6,53.1-37.3c-0.5-0.2-1.1-0.5-1.6-0.7c-11.3-5.1-17.2-14.6-28.1-21.3 c-23.6-14.3-57.5,3.2-77.7,17.1c-4.5,3.1-8.7,5.3-12.6,6.9c1.4,2.6,2.9,5,4.5,7.3C313.3,79.1,338.5,90.2,362.6,86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M477.7,148.5c-0.2-5.1-0.4-9.8-0.7-13c-2.2-24.3-0.2-51.6-19-67.7c-6.4,29.8,0.8,60.1,4.1,89.8 c3.7-1.9,7.4-4,11-6.2C474.7,150.5,476.2,149.5,477.7,148.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#41210D",
    d: "M276,91.4c43.3,27.2,107.1,28.3,149.1-2.5c-14.4,29.6-59.9,33.5-88.8,31C311.1,117.5,295.2,109.9,276,91.4 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M326,134.4c-8.1,12.8-14.4,24.3-25.5,39.1c4,1.1,8,2,12.1,2.8c11.5-15.4,17.9-27.2,26.5-40.7 C334.6,135.4,330.3,135,326,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7B6",
    d: "M379,135.8c-9.7,14.7-20.7,31.7-32,45c16.5,0.9,33.2,0.1,49.5-2.4c9.7-15.1,18.8-33.5,26.6-49.1 C408.7,132.7,393.9,134.8,379,135.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat3NewHair1);
export default __webpack_public_path__ + "static/media/m-hat3_new-hair1.a46c2d719bc6ebe8d709922ae7da3d09.svg";
export { ForwardRef as ReactComponent };